module.exports = __webpack_public_path__ + "static/media/Follower_Button-7.45fc0b32.png";